let latestElementId = 1;
export const getNextElementId = () => ++latestElementId;
export const resetElementIdGenerator = (usedIds) => {
    latestElementId = usedIds?.length ? Math.max(...usedIds) : 1;
};
//# sourceMappingURL=id-generator.js.map